export default {
    getPrintGroupsId: state => {
        return Object.entries(state.printGroups).map(([id, group]) => ({
            id,
            ...group,
        }))
    },

    getPrintGroupProgress: state => groupId => {
        const group = state.printGroups[groupId]
        if (!group) return null

        const localTotal = group.orders.length
        const localSuccess = group.orders.filter(
            o => o.printStatus === 'success'
        ).length
        const localError = group.orders.filter(
            o => o.printStatus === 'error'
        ).length
        // После ресинка агрегат сервера становится источником прогресса для UI
        const { serverProgress } = group

        if (!serverProgress) {
            return {
                total: localTotal,
                completed: localSuccess + localError,
                success: localSuccess,
                error: localError,
            }
        }

        const { total = localTotal, completed = 0, failed = 0 } = serverProgress
        const success = completed - failed
        const error = failed

        return { total, completed, success, error }
    },

    isGroupCompleted: state => groupId => {
        const group = state.printGroups[groupId]
        if (!group) return false

        return group.orders.every(
            o => o.printStatus === 'success' || o.printStatus === 'error'
        )
    },

    getGroupErrors: state => groupId => {
        const group = state.printGroups[groupId]
        if (!group) return []

        return group.orders
            .filter(o => o.printStatus === 'error' && o.errorText)
            .map(o => o.errorText)
    },

    getRouteById: state => id => {
        return state.routes.find(route => route.id === id) ?? null
    },
}
